import { getTodaysReturns } from "@services/api";
import {
  FETCH_RETURNS_REQUEST,
  FETCH_RETURNS_SUCCESS,
  FETCH_RETURNS_FAILURE,
} from "../reducers/actionTypes";

interface FetchReturnsRequestAction {
  type: typeof FETCH_RETURNS_REQUEST;
}

interface FetchReturnsSuccessAction {
  type: typeof FETCH_RETURNS_SUCCESS;
  payload: Record<string, ReturnStats>;
}

interface FetchReturnsFailureAction {
  type: typeof FETCH_RETURNS_FAILURE;
  payload: string;
}

export interface ReturnsState {
  data: Record<string, ReturnStats>;
  loading: boolean;
  error: string | null;
}

export interface ReturnStats {
  id: string;
  quantity: number;
  refundAmount: number;
}

export type ReturnsActionTypes =
  | FetchReturnsRequestAction
  | FetchReturnsSuccessAction
  | FetchReturnsFailureAction;

import { Dispatch } from "redux";

export const fetchReturnsRequest = (): ReturnsActionTypes => ({
  type: FETCH_RETURNS_REQUEST,
});

export const fetchReturnsSuccess = (
  data: Record<string, any>,
): ReturnsActionTypes => ({
  type: FETCH_RETURNS_SUCCESS,
  payload: data,
});

export const fetchReturnsFailure = (error: string): ReturnsActionTypes => ({
  type: FETCH_RETURNS_FAILURE,
  payload: error,
});

export const fetchReturns = ({
  date,
  spokeName,
}: {
  date: string;
  spokeName: string;
}) => {
  return async (dispatch: Dispatch<ReturnsActionTypes>) => {
    dispatch(fetchReturnsRequest());
    try {
      const response = await getTodaysReturns({
        date,
        spokeName,
      });
      dispatch(fetchReturnsSuccess(response.data));
    } catch (error) {
      dispatch(fetchReturnsFailure("Failed to fetch return stats"));
    }
  };
};
